import {
  Box,
  Container,
  Typography,
} from "@mui/material";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import logo from "../../assets/img/img.png";


export const Mapa = () => {
 const { ref, inView } = useInView({
  threshold: 0.3,
  triggerOnce: false
});


const aparecer = {
  hidden:{
    opacity:0,
    scale:.9,
    y:60
  },

  visible:{
    opacity:1,
    scale:1,
    y:0,

    transition:{
      duration:1,
      ease:[0.22,1,0.36,1]
    }
  }
};
const historia = [

{
 año:"1995",
 titulo:"Inicios del Colegio",
 texto:
 "Nuestro colegio se fundó el 30 de octubre de 1995. Iniciando las clases en marzo de 1996, recibiendo a todas las familias de la zona.",
 icon:<FlagOutlinedIcon/>
},

{
 año:"2005",
 titulo:"Implementación Taller Adle",
 texto:
 "Se instauran nuestras ACLES que contribuyen al desarrollo físico, mental y emocional de nuestros estudiantes.",
 icon:<MenuBookOutlinedIcon/>
},

{
 año:"2017",
 titulo:"Implementación Proyecto Mensed",
 texto:
 "Implementación Proyecto Mensed, Propuesta Metodológica Interdisciplinaria para el Desarrollo de Competencias Científicas.",
 icon:<StarBorderOutlinedIcon/>
},

{
 año:"2019",
 titulo:"Nueva Administración",
 texto:
 "Corporación Grande Fede asume la responsabilidad de darle continuidad al proyecto educativo.",
 icon:<GroupsOutlinedIcon/>
}

];
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        py: {
          xs: 8,
          md: 12,
        },

      }}
    >

      <Container maxWidth="lg">

       <Box
  ref={ref}
  component={motion.div}

  variants={aparecer}

  initial="hidden"

  animate={
    inView 
    ? "visible" 
    : "hidden"
  }

  sx={{
    background:
    "linear-gradient(135deg,#12213F 0%,#172F55 50%,#0B1930 100%)",

    borderRadius:'40px',

    position:"relative",

    display:"flex",

    alignItems:"center",

    p:{
      xs:4,
      md:10
    },

    overflow:"hidden"
  }}
>


          {/* COMILLAS DECORATIVAS */}
          <Typography
            sx={{
              position:"absolute",
              top:{
                xs:-30,
                md:-10
              },
              left:{
                xs:0,
                md:0
              },

              fontFamily:"Archivo",
              fontSize:{
                xs:"8rem",
                md:"10rem"
              },

              fontWeight:900,
              lineHeight:1,

              color:"#C62828",

              opacity:.9,

              zIndex:1
            }}
          >
            “
          </Typography>


          {/* TEXTO */}
          <Box
            sx={{
              position:"relative",
              zIndex:2,
              width:{
                xs:"100%",
                md:"55%"
              }
            }}
          >

            <Typography
              sx={{
                fontFamily:"Archivo",
                color:"#fff",
                fontWeight:600,

                fontSize:{
                  xs:"1rem",
                  md:"1.8rem"
                },

                lineHeight:1.15,

                letterSpacing:-1
              }}
            >
              Creemos que educar es formar
              <Box
                component="span"
                sx={{
                  color:"#C62828",
                  display:"block"
                }}
              >
                personas íntegras,
              </Box>

              preparadas para construir
              <Box
                component="span"
                sx={{
                  color:"#fff"
                }}
              >
                {" "}un mejor futuro
              </Box>

            </Typography>


            <Box
              sx={{
                mt:4,
                width:90,
                height:4,
                borderRadius:5,
                background:"#C62828"
              }}
            />

          </Box>



          {/* LOGO DIFUMINADO */}
         <Box
component={motion.div}
animate={{
  scale:[1,1.05,1],
  opacity:[0.12,0.18,0.12]
}}

transition={{
  duration:5,
  repeat:Infinity,
  ease:"easeInOut"
}}

sx={{
 position:"absolute",
 right:{
   xs:-120,
   md:-50
 },
 top:"50%",
 transform:"translateY(-50%)",
 width:{
   xs:200,
   md:300
 },
 filter:"blur(1px)",
 zIndex:0
}}
>

            <Box
              component="img"
              src={logo}
              alt="Colegio Antilen"
              sx={{
                width:"100%",
                height:"100%",
                objectFit:"contain"
              }}
            />

          </Box>


        </Box>

      </Container>
      <Container
 ref={ref}
 maxWidth="lg"
 sx={{
   py:12,
   overflow:"hidden"
 }}
>


<Typography
sx={{
 textAlign:"center",
 color:"#C62828",
 fontFamily:"Archivo",
 fontWeight:700,
 letterSpacing:2,
 fontSize:{
  xs:"1rem",
  md:"2rem"
 }
}}
>
NUESTRA HISTORIA
</Typography>



<Typography
sx={{
 textAlign:"center",
 fontFamily:"Archivo",
 fontWeight:700,
 color:"#12213F",
 fontSize:{
  xs:"2rem",
  md:"2.8rem"
 }
}}
>
Hitos que nos han marcado
</Typography>



<Box
sx={{
 position:"relative",
 mt:8
}}
>


{/* LINEA CENTRAL */}

<Box
component={motion.div}
initial={{
 width:0
}}
animate={inView?{
 width:"100%"
}:{
 width:0
}}

transition={{
 duration:2,
 ease:"easeInOut"
}}

sx={{
 position:"absolute",
 top:80,
 left:0,
 height:"2px",
 background:
 "linear-gradient(90deg,#C62828,#561c33)",
}}
/>



<Box
sx={{
 display:"grid",
 gridTemplateColumns:{
  xs:"1fr",
  md:"repeat(4,1fr)"
 },
 gap:5,
 position:"relative"
}}
>


{
historia.map((item,index)=>(


<Box
key={index}
component={motion.div}

initial={{
 opacity:0,
 y:index%2===0?70:-70
}}

animate={inView?{
 opacity:1,
 y:0
}:{
 opacity:0,
 y:index%2===0?70:-70
}}

transition={{
 duration:.8,
 delay:index*.35,
 ease:[.22,1,.36,1]
}}

sx={{
 position:"relative",
 textAlign:"center"
}}
>


{/* AÑO */}

<Typography
sx={{
 fontWeight:700,
 color:"#12213F",
 fontSize:"1.3rem",
 mb:2
}}
>
{item.año}
</Typography>



{/* ICONO */}

<Box
component={motion.div}

initial={{
 scale:0
}}

animate={inView?{
 scale:1
}:{
 scale:0
}}

transition={{
 delay:.4+index*.35,
 type:"spring"
}}

sx={{
 width:72,
 height:72,
 mx:"auto",
 borderRadius:"50%",
 background:
 "linear-gradient(135deg,#C62828,#8f1515)",
 color:"#fff",

 display:"flex",
 justifyContent:"center",
 alignItems:"center",

 position:"relative",
 zIndex:2,

 boxShadow:
 "0 15px 35px rgba(198,40,40,.35)"
}}

>

{
item.icon
}

</Box>




{/* CARD */}


<Box
sx={{
 mt:0,
 background:"#fff",

 borderRadius:"18px",

 p:3,

 minHeight:300,

 boxShadow:
 "0 15px 40px rgba(18,33,63,.10)",

 border:"1px solid rgba(0,0,0,.05)"
}}
>


<Typography
sx={{
 fontFamily:"Archivo",
 fontWeight:700,
 color:"#12213F",
 fontSize:"1.1rem"
}}
>
{item.titulo}
</Typography>


<Box
sx={{
 width:45,
 height:3,
 background:"#C62828",
 mx:"auto",
 my:2
}}
/>



<Typography
sx={{
 color:"#606C80",
 fontSize:15,
 lineHeight:1.6
}}
>
{item.texto}
</Typography>


</Box>


</Box>

))

}


</Box>


</Box>


</Container>

    </Box>
  );
};